import { NakedButton } from '@cb/apricot-react';
import ArticleIcon from '@mui/icons-material/Article';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { styled } from '@mui/system';

import { TAIFormProcessStatus, ISummary } from 'src/types';

const ActionList = styled('div')`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
`;

const ActionButton = styled(NakedButton)`
  padding: 0;
`;

interface RequestActionsProps {
  request: ISummary;
  onStatusUpdate: (request: ISummary, processStatus: TAIFormProcessStatus) => void;
  onClickApprove: (request: ISummary) => void;
  onClickDenied: (request: ISummary) => void;
  onClickNeedMoreInfo: (request: ISummary) => void;
}

export const RequestActions = ({
  request,
  onClickApprove,
  onClickDenied,
  onClickNeedMoreInfo,
  onStatusUpdate,
}: RequestActionsProps) => {

  const handleClickApproved = () => {
    onClickApprove(request);
  };

  const handleClickPendingReview = () => {
    onStatusUpdate(request, 'processing');
  };

  const handleClickDenied = () => {
    onClickDenied(request);
  };

  const handleClickNeedMoreInformation = () => {
    onClickNeedMoreInfo(request);
  };

  const handleClickPendingAppeal = () => {
    onStatusUpdate(request, 'appeal');
  };

  const handleClickPendingInternational = () => {
    onStatusUpdate(request, 'international');
  };

  const handleClickPendingTestSecurity = () => {
    onStatusUpdate(request, 'testSecurity');
  };

  const handleClickOPSApproved = () => {
    onStatusUpdate(request, 'opsApproved');
  };

  switch (request.processStatus) {
    case 'submitted':
      return (
        <ActionList>
          <ActionButton onClick={handleClickPendingReview}>
            <ArticleIcon />
            Pending Review
          </ActionButton>
        </ActionList>
      );

    case 'processing':
      return (
        request.requestType === 'create' ?
          <ActionList>
            <ActionButton onClick={handleClickApproved}>
              <CheckIcon />
              Approved
            </ActionButton>
            <ActionButton onClick={handleClickDenied}>
              <CloseIcon />
              Denied
            </ActionButton>
            <ActionButton onClick={handleClickNeedMoreInformation}>
              <BorderColorIcon />
              Need More Information
            </ActionButton>
            <ActionButton onClick={handleClickPendingAppeal}>
              <BorderColorIcon />
              Pending Appeal
            </ActionButton>
            <ActionButton onClick={handleClickPendingInternational}>
              <BorderColorIcon />
              Pending International
            </ActionButton>
            <ActionButton onClick={handleClickPendingTestSecurity}>
              <BorderColorIcon />
              Pending Test Security
            </ActionButton>
            <ActionButton onClick={handleClickOPSApproved}>
              <BorderColorIcon />
              Vetting Approved
            </ActionButton>
          </ActionList> :
          <ActionList>
            <ActionButton onClick={handleClickApproved}>
              <CheckIcon />
              Approved
            </ActionButton>
            <ActionButton onClick={handleClickDenied}>
              <CloseIcon />
              Denied
            </ActionButton>
          </ActionList>
      );

    case 'appeal':
      return (
        <ActionList>
          <ActionButton onClick={handleClickApproved}>
            <CheckIcon />
            Approved
          </ActionButton>
          <ActionButton onClick={handleClickDenied}>
            <CloseIcon />
            Denied
          </ActionButton>
          <ActionButton onClick={handleClickNeedMoreInformation}>
            <BorderColorIcon />
            Need More Information
          </ActionButton>
          <ActionButton onClick={handleClickPendingInternational}>
            <BorderColorIcon />
            Pending International
          </ActionButton>
          <ActionButton onClick={handleClickPendingTestSecurity}>
            <BorderColorIcon />
            Pending Test Security
          </ActionButton>
          <ActionButton onClick={handleClickOPSApproved}>
            <BorderColorIcon />
            Vetting Approved
          </ActionButton>
        </ActionList>
      );
    case 'international':
      return (
        <ActionList>
          <ActionButton onClick={handleClickApproved}>
            <CheckIcon />
            Approved
          </ActionButton>
          <ActionButton onClick={handleClickDenied}>
            <CloseIcon />
            Denied
          </ActionButton>
          <ActionButton onClick={handleClickNeedMoreInformation}>
            <BorderColorIcon />
            Need More Information
          </ActionButton>
          <ActionButton onClick={handleClickPendingAppeal}>
            <BorderColorIcon />
            Pending Appeal
          </ActionButton>
          <ActionButton onClick={handleClickPendingTestSecurity}>
            <BorderColorIcon />
            Pending Test Security
          </ActionButton>
          <ActionButton onClick={handleClickOPSApproved}>
            <BorderColorIcon />
            Vetting Approved
          </ActionButton>
        </ActionList>
      );
    case 'testSecurity':
      return (
        <ActionList>
          <ActionButton onClick={handleClickApproved}>
            <CheckIcon />
            Approved
          </ActionButton>
          <ActionButton onClick={handleClickDenied}>
            <CloseIcon />
            Denied
          </ActionButton>
          <ActionButton onClick={handleClickNeedMoreInformation}>
            <BorderColorIcon />
            Need More Information
          </ActionButton>
          <ActionButton onClick={handleClickPendingAppeal}>
            <BorderColorIcon />
            Pending Appeal
          </ActionButton>
          <ActionButton onClick={handleClickPendingInternational}>
            <BorderColorIcon />
            Pending International
          </ActionButton>
          <ActionButton onClick={handleClickOPSApproved}>
            <BorderColorIcon />
            Vetting Approved
          </ActionButton>
        </ActionList>
      );
    case 'opsApproved':
      return (
        <ActionList>
          <ActionButton onClick={handleClickApproved}>
            <CheckIcon />
            Approved
          </ActionButton>
          <ActionButton onClick={handleClickDenied}>
            <CloseIcon />
            Denied
          </ActionButton>
          <ActionButton onClick={handleClickNeedMoreInformation}>
            <BorderColorIcon />
            Need More Information
          </ActionButton>
          <ActionButton onClick={handleClickPendingAppeal}>
            <BorderColorIcon />
            Pending Appeal
          </ActionButton>
          <ActionButton onClick={handleClickPendingInternational}>
            <BorderColorIcon />
            Pending International
          </ActionButton>
          <ActionButton onClick={handleClickPendingTestSecurity}>
            <BorderColorIcon />
            Pending Test Security
          </ActionButton>
        </ActionList>
      );

    default:
      return null;
  }
};
